import React from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Router from './Router';
import theme from './theme';
import NotificationProvider from 'context/Notification.context';
import { AccordionProvider } from 'context/AccordionContext';
import RolesProvider from 'context/Roles.context';
import VSpecProvider from 'context/Vspec.context';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const entraAuthority =
  'https://login.microsoftonline.com/417ca393-15d2-4e55-beec-87affb35daa4/v2.0';
const redirectUri = `${window.location.origin}/`;

const oidcConfig = {
  onSigninCallback: () => {
    const pathname = sessionStorage.getItem('cube-pathname') || '/';
    sessionStorage.removeItem('cube-pathname');
    window.history.replaceState(null, '', window.location.origin + pathname);
  },
  authority: entraAuthority,
  client_id: 'd6f95db5-f7e9-4698-9635-0ad4ca8bcf99',
  response_type: 'code',
  redirect_uri: redirectUri,
  scope: 'api://417ca393-15d2-4e55-beec-87affb35daa4/DSMOTD/TMNA.Access',
  post_logout_redirect_uri: redirectUri,
};

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <CssBaseline />
          <RolesProvider>
            <VSpecProvider>
              <AccordionProvider>
                <NotificationProvider>
                  <Router />
                </NotificationProvider>
              </AccordionProvider>
            </VSpecProvider>
          </RolesProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>,
);
